import GenericCircuitBenefitAdditionModal, {
  CircuitBenefitAdditionModalProps,
} from './GenericCircuitBenefitAdditionModal';

const AddExcursionBenefitModal = (props: CircuitBenefitAdditionModalProps) => (
  <GenericCircuitBenefitAdditionModal {...props} modalType="Activités" />
);

export default AddExcursionBenefitModal;
